import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X, Ruler } from "lucide-react";

export default function SizeGuideModal({ product, onClose }) {
  const [unit, setUnit] = useState("in");
  const guide = product.size_guide;

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose]);

  if (!guide?.rows?.length) return null;

  return createPortal(
    <div className="fixed inset-0 z-[95] bg-ink/90 backdrop-blur-sm flex items-center justify-center p-4"
      data-testid="size-guide-modal" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="bg-ink border border-border w-full max-w-2xl max-h-[85vh] overflow-y-auto p-6 sm:p-8 relative">
        <button onClick={onClose} data-testid="size-guide-modal-close" aria-label="Close size guide"
          className="absolute top-4 right-4 w-10 h-10 bg-chalk text-ink hover:bg-pulse transition-colors flex items-center justify-center">
          <X size={18} />
        </button>
        <p className="eyebrow !mb-1 flex items-center gap-2"><Ruler size={13} className="text-signal" /> Size Guide</p>
        <h2 className="font-anton uppercase text-2xl sm:text-3xl mb-1">{product.name}</h2>
        <p className="text-graphite text-sm mb-5">{product.fit}</p>

        <div className="flex gap-1 mb-4">
          {["in", "cm"].map((u) => (
            <button key={u} onClick={() => setUnit(u)} data-testid={`sg-unit-${u}`}
              className={`font-mono text-[10px] uppercase tracking-wider px-4 py-1.5 border transition-colors ${
                unit === u ? "bg-chalk text-ink border-chalk" : "border-border text-graphite hover:border-chalk"
              }`}>{u === "in" ? "Inches" : "CM"}</button>
          ))}
        </div>

        <div className="overflow-x-auto">
          <table className="w-full font-mono text-xs" data-testid="size-guide-modal-table">
            <thead>
              <tr className="text-left uppercase tracking-wider text-chalk/70 border-b border-border">
                <th className="py-2.5 pr-4 font-normal">Size</th>
                {guide.columns.map((c) => (
                  <th key={c} className="py-2.5 pr-4 font-normal">{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {guide.rows.map((r) => (
                <tr key={r.size} className="border-b border-border/50">
                  <td className="py-2.5 pr-4 text-chalk">{r.size}</td>
                  {r.values.map((v, i) => (
                    <td key={guide.columns[i]} className="py-2.5 pr-4 text-chalk/80">
                      {unit === "in" ? `${v[0]}"` : `${v[1]} cm`}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-graphite text-[11px] font-mono mt-4 leading-relaxed">
          Measurements are of the garment laid flat. Measure a piece you own and compare.
          1–3 cm differences may occur — every SYNC piece is made to order.
        </p>
      </div>
    </div>,
    document.body
  );
}
